interface Props {
  [key: string]: any
}

function ExclamationStrokeIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 6 20" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M3.32863 5.17989C2.6131 5.17989 2.02478 4.97319 1.56366 4.55977C1.11844 4.13045 0.895831 3.60573 0.895831 2.98561C0.895831 2.34958 1.11844 1.82486 1.56366 1.41145C2.02478 0.98213 2.6131 0.767472 3.32863 0.767472C4.02825 0.767472 4.60068 0.98213 5.04589 1.41145C5.50701 1.82486 5.73757 2.34958 5.73757 2.98561C5.73757 3.60573 5.50701 4.13045 5.04589 4.55977C4.60068 4.97319 4.02825 5.17989 3.32863 5.17989ZM5.35596 6.56325V19.8721H1.27745V6.56325H5.35596Z"
        fill="#A840C8"
      />
    </svg>
  )
}

export default ExclamationStrokeIcon
